import React from 'react';
import styles from './Form.module.scss';

export const Prompt = () => (
  <p className={styles.prompt}>
    Select a column in the list from downloaded CSV file to match it with a column in BOL Logs table
  </p>
);
